module.exports = __webpack_public_path__ + "img/6.90869f0f.jpg";